import { render, staticRenderFns } from "./EditTransactionHub.vue?vue&type=template&id=81e89c4e&scoped=true&"
import script from "./EditTransactionHub.vue?vue&type=script&lang=js&"
export * from "./EditTransactionHub.vue?vue&type=script&lang=js&"
import style0 from "./EditTransactionHub.vue?vue&type=style&index=0&id=81e89c4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81e89c4e",
  null
  
)

export default component.exports